<template>
  <div>
    <v-layout column>
      <v-flex md12 mt-3>
        <v-card>
          <v-card-title primary-title>
            <v-layout wrap>
              <v-flex md12>
                <v-select
                  :items="packages"
                  v-model="selectedPackage"
                  item-text="name"
                  item-value="id"
                  label="Pacote"
                  clearable
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-flex md12
                ><v-list
                  style="height: 300px; border: 1px solid;"
                  class="overflow-y-auto"
                >
                  <template
                    v-for="(passenger, index) in this.applicableToPassengers"
                  >
                    <v-list-item
                      @click="selectPassenger(passenger)"
                      :key="`passenger_${index}`"
                    >
                      <v-list-item-action>
                        <v-icon v-if="selectedPassengers.includes(passenger.id)"
                          >check_box</v-icon
                        >
                        <v-icon v-else>check_box_outline_blank</v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          passenger.customerName
                        }}</v-list-item-title>
                        <v-list-item-subtitle>{{
                          passenger.packageName
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider :key="`divider_passenger_${index}`"></v-divider>
                  </template>
                </v-list>
              </v-flex>
              <v-flex md12>
                <v-toolbar color="transparent" dense flat>
                  <v-toolbar-side-icon
                    :disabled="selectedPassengers.length == 0"
                    @click="selectedPassengers = []"
                  >
                    <v-icon>clear</v-icon>
                  </v-toolbar-side-icon>
                  <v-toolbar-title class="body-2 grey--text">
                    {{ this.selectedPassengers.length }} de
                    {{ this.applicableToPassengers.length }} selecionados
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-text-field
                      name="busNumber"
                      label="Onibus"
                      id="busNumber"
                      v-model="selectedBus"
                      v-on:keyup.enter="addSelectedPassengersToBus"
                    ></v-text-field>
                    <v-btn
                      color="primary"
                      :disabled="
                        !this.selectedBus || this.selectedPassengers.length == 0
                      "
                      @click="addSelectedPassengersToBus"
                      text
                      icon
                    >
                      <v-icon>check</v-icon>
                    </v-btn>
                  </v-toolbar-items>
                </v-toolbar>
              </v-flex>
              <v-flex md12
                ><v-list
                  style="height: 300px; border: 1px solid;"
                  class="overflow-y-auto"
                >
                  <template
                    v-for="(passenger, index) in this.allocatedPassengers"
                  >
                    <v-list-item :key="`allocated_passenger_${index}`">
                      <v-list-item-action
                        @click="removePassengerAllocation(passenger)"
                      >
                        <v-icon>delete</v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          passenger.customerName
                        }}</v-list-item-title>
                        <v-list-item-subtitle>{{
                          passenger.packageName
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        {{ passenger.allocation.bus }}
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider
                      :key="`divider_allocated_passenger_${index}`"
                    ></v-divider>
                  </template>
                </v-list>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import api from "@/api";
export default {
  props: ["tripId", "passengers"],
  data() {
    return {
      packages: [],
      selectedPackage: null,
      selectedBus: null,
      selectedPassengers: [],
      allocations: []
    };
  },
  computed: {
    applicableToPassengers() {
      var packages =
        this.selectedPackage == null
          ? this.packages
          : this.packages.filter(p => p.id == this.selectedPackage);

      return this.passengers.filter(
        passenger =>
          packages.map(p => p.id).includes(passenger.packageId) &&
          (this.allocations.length == 0 ||
            this.allocations.filter(a => a.passengerId == passenger.id)
              .length == 0)
      );
    },
    allocatedPassengers() {
      return this.passengers
        .filter(
          passenger =>
            this.allocations.length > 0 &&
            this.allocations.filter(a => a.passengerId == passenger.id).length >
              0
        )
        .map(passenger => {
          var allocation = this.allocations.filter(
            a => a.passengerId == passenger.id
          )[0];
          return Object.assign(passenger, { allocation: allocation });
        });
    }
  },
  methods: {
    selectPassenger(passenger) {
      if (!this.selectedPassengers.includes(passenger.id)) {
        this.selectedPassengers.push(passenger.id);
      } else {
        this.selectedPassengers = this.selectedPassengers.filter(
          id => id != passenger.id
        );
      }
    },
    addSelectedPassengersToBus() {
      if (!this.selectedBus || this.selectedPassengers.length == 0) return;

      var allocations = this.selectedPassengers.map(passengerId => {
        var passenger = this.passengers.filter(p => p.id == passengerId)[0];
        return {
          passengerId: passenger.id,
          bus: this.selectedBus
        };
      });

      this.allocations = this.allocations.concat(allocations);

      //Add remotely
      api
        .request(
          "POST",
          `/trips/${this.tripId}/organization/busList`,
          allocations
        )
        .then(() => {
          console.log("Success");
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.fetchAllocations();
        });

      this.selectedPassengers = [];
    },
    removePassengerAllocation(passenger) {
      var indexToRemove = this.allocations.findIndex(
        a => a.passengerId == passenger.id
      );

      var allocationsToRemove = this.allocations.splice(indexToRemove, 1);

      //Remove remotely
      api
        .request(
          "DELETE",
          `/trips/${this.tripId}/organization/busList`,
          allocationsToRemove
        )
        .then(() => {
          console.log("Success");
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.fetchAllocations();
        });
    },
    fetchAllocations() {
      api
        .request("GET", `/trips/${this.tripId}/organization/busList`)
        .then(response => {
          this.allocations = response.data.allocations || [];
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    api
      .request("GET", `/trips/${this.tripId}/package`)
      .then(response => {
        this.packages = response.data.packages || [];
      })
      .catch(error => {
        console.log(error);
      });

    this.fetchAllocations();
  }
};
</script>
